import{styleInject as n}from"./externals/style-inject.js";n(".coral-icon {\n  font-size: 24px;\n  width: 1em;\n  height: 1em;\n}\n",{insertAt:"top"});
